import { Enums } from '@cornerstonejs/metadata';
export default Enums.MetadataModules;
